(() => {
  const showBenefitCardSlider = () => {
    const benefitCardSlider = document.querySelector(".BenefitCardSlider");

    if (benefitCardSlider) {
      benefitCardSlider.classList.add("-Active");
    }
  };

  const hideBenefitCardSlider = () => {
    const benefitCardSlider = document.querySelector(".BenefitCardSlider");

    if (benefitCardSlider) {
      benefitCardSlider.classList.remove("-Active");
    }
  };

  const showPageOverlay = () => {
    const pageOverlay = document.querySelector(".PageOverlay");

    if (pageOverlay) {
      pageOverlay.classList.add("is-visible");
      document.querySelector('body').classList.add('unset-overflow');
    }
  };

  const hidePageOverlay = () => {
    const pageOverlay = document.querySelector(".PageOverlay");

    if (pageOverlay) {
      pageOverlay.classList.remove("is-visible");
      document.querySelector('body').classList.remove('unset-overflow');
    }
  };

  const disableBodyScroll = () => {
    if (typeof window.disableBodyScroll === "function") {
      window.disableBodyScroll(true, "[data-scrollable]");
      document.documentElement.classList.add("no-scroll");
    }
  };

  const enableBodyScroll = () => {
    if (typeof window.disableBodyScroll === "function") {
      window.disableBodyScroll(false, "[data-scrollable]");
      document.documentElement.classList.remove("no-scroll");
    }
  };

  const benefitsSection = document.querySelector(".Benefits");

  if (benefitsSection) {
    const benefitCardSlider = document.querySelector(".BenefitCardSlider");
    const pageOverlay = document.querySelector(".PageOverlay");

    // Move the BenefitCardSlider on the same level as the PageOverlay
    // to make sure we can consistently show the slider above the overlay (z-index)
    pageOverlay.parentNode.insertBefore(
      benefitCardSlider,
      pageOverlay.nextSibling
    );

    // const benefitCardSwiper = new window.Swiper(".BenefitCardSlider .swiper", {
    //   slidesPerView: 1,
    //   spaceBetween: 32,
    //   grabCursor: true,
    //   navigation: {
    //     nextEl: ".BenefitCardSlider .swiper-button-next",
    //     prevEl: ".BenefitCardSlider .swiper-button-prev",
    //   },
    //   pagination: {
    //     el: ".BenefitCardSlider .swiper-pagination",
    //     clickable: true,
    //   },
    // });

    benefitsSection
      .querySelectorAll(".BenefitItem, .BenefitBadge")
      .forEach((item, index) => {
        item.addEventListener("click", () => {
          // Speed is set to '0' so the transition is not visible to the user
          benefitCardSwiper.slideTo(index, 0);

          disableBodyScroll();
          showPageOverlay();

          setTimeout(() => showBenefitCardSlider(), 150);
        });
      });

    document
      .querySelectorAll(".BenefitCardSlider__CloseButton, .PageOverlay")
      .forEach((item) => {
        item.addEventListener("click", () => {
          enableBodyScroll();
          hideBenefitCardSlider();

          setTimeout(() => hidePageOverlay(), 150);
        });
      });
  }
})();